import { NotificationPriority } from '@shared/types';

export type NotificationSeverity = 'info' | 'warning' | 'critical';

export const notificationSeverityStyles: Record<
  NotificationSeverity | NotificationPriority,
  {
    borderClassName: string;
    iconClassName: string;
    actionClassName: string;
  }
> = {
  [NotificationPriority.Info]: {
    borderClassName: 'border-success-100',
    iconClassName: 'text-success-500',
    actionClassName:
      'border-success-500 bg-success-500 text-white hover:bg-success-500/90 hover:text-white',
  },
  [NotificationPriority.Warning]: {
    borderClassName: 'border-orange-200',
    iconClassName: 'text-orange-500',
    actionClassName:
      'border-orange-500 bg-orange-500 text-white hover:bg-orange-500/90 hover:text-white',
  },
  [NotificationPriority.Critical]: {
    borderClassName: 'border-red-200',
    iconClassName: 'text-red-500',
    actionClassName:
      'border-red-500 bg-red-500 text-white hover:bg-red-500/90 hover:text-white',
  },
};
